// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
import { getAI, getGenerativeModel, GoogleAIBackend } from "firebase/ai";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Your web app's Firebase configuration
// Replace these values with your actual Firebase configuration from the Firebase Console
export const firebaseConfig = {
  apiKey: "AIzaSyCh_bHNRKTtEq5k-XtPQd8KQPx4Ub6W9vg",
  authDomain: "thought-code.firebaseapp.com",
  projectId: "thought-code",
  storageBucket: "thought-code.firebasestorage.app",
  messagingSenderId: "333584179048",
  appId: "1:333584179048:web:549c881c92b833227f00dd",
  measurementId: "G-23W6YY3W1L",
};

// Initialize Firebase App
export const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Export Firebase Functions instance
export const functions = getFunctions(app);

// --- Gemini AI Logic ---
export const ai = getAI(app, { backend: new GoogleAIBackend() });
export const geminiModel = getGenerativeModel(ai, { model: "resume-score" }); // or "gemini-1.5-flash" etc.

// Export auth getter for consistency with existing code
export const getCurrentAuth = () => {
  return auth;
};

// Initialize App Check
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(app, {
  // You can get a reCAPTCHA v3 site key from the Google Cloud console.
  // This is a public key, so it's safe to include in your code.
  //if App Check enforcement is enabled,get the real reCAPTCHA v3 site key and add ReCaptchaV3Provider
  provider: new ReCaptchaV3Provider('YOUR_RECAPTCHA_V3_SITE_KEY'),
  isTokenAutoRefreshEnabled: true
});
